import $ from 'jquery';
import Inputmask from "inputmask";
(Inputmask as any).extendDefaults({}); // optional

// Import utilities from ajax.utils.ts
import { InCoreReloadPartial, InCoreReloadPartialAsync, InCoreReloadDivs, InCoreAjaxRedirect } from "../Core/utils/ajax.utils";
// Import utilities from validation.utils.ts
import { isNumber } from "../Core/utils/validation.utils";
// Import utilities from toast.utils.ts
import { InCoreToast, InCoreToastX, InCoreToastCustom, InCoreToastType, InCoreToastPosition } from "../Core/utils/toast.utils";
// Import utilities from tabpanel.utils.ts
import { initializeTabPanels, activateTabPanel } from "../Core/utils/tabpanel.utils";
// Import utilities from summernote.utils.ts
import { initializeSummernote, activateSummernote } from "../Core/utils/summernote.utils";
// Import utilities from select2.utils.ts
import { initializeSelect2, InCoreSelect2, configureSelect2, InCoreSelect2Filter } from "../Core/utils/select2.utils";
// Import utilities from notification.utils.ts
import { InCoreNotifier } from "../Core/utils/notification.utils";
// Import utilities from permissions.utils.ts
import { InCoreCheckPermission, InCoreHasPermission } from "../Core/utils/permissions.utils";
// Import utilities from modal.utils.ts
import { InCoreModal, CloseModal, CloseModalPromise, ClearModal, InCoreModalAction, InCoreModalLayout } from "../Core/utils/modal.utils";
// Import utilities from dropzone.utils.ts
import { initializeDropzones, initDropzone, createDropzone, preparaFormDropzone } from "../Core/utils/dropzone.utils";
// Import utilities from dom.utils.ts
import { getBtn, getParentBtn } from "../Core/utils/dom.utils";
// Import utilities from datatable.utils.ts
import {
    InCoreDT,
    InCoreDTCustom,
    InCoreDTFromModel,
    InCoreReadDTConfig,
    DTManageActions,
    loadDataTablesFromJSON,
    formatColumns,
    InCoreDTActions,
    //PaginationConfiguration,
} from "../Core/utils/datatable.utils";
// Import utilities from flatpickr.utils.ts
import { initializeDateTimePickers, InCoreDateTimePickerConfig, InCoreDateTimePickers, createDateTimePicker, InCoreDateTimePickerModes } from "../Core/utils/flatpickr.utils";
// Import utilities from format.utils.ts
import { InCoreFlashColor, InCoreFlashBorder } from "../Core/utils/format.utils";
// Import utilities from chart.utils.ts
import { InCoreChartResizeOnWindow, InCoreChartDestroy, InCoreChartGetDataset } from "../Core/utils/chart.utils";
// Import utilities from calendar.utils.ts
import { InCoreCalendarWindowType, initializeCalendars, inCoreCalendar, inCoreCalendarCustom, refreshCalendars, adjustCalendarHeight, closeMoreLinkPopover } from "../Core/utils/calendar.utils";
// Import utilities from swal.utils.ts
import { InCoreSwal2, InCoreSwal2Icon, InCoreSwal2Type, InCoreSwal2X, InCoreSwal2Custom, InCoreSwal2CustomPartial } from "../Core/utils/swal.utils";
// Import utilities from document.utils.ts
import {
    BoldLastWordOfBreadcrumb,
    InCoreApplyPermissionsDefault,
    InCoreApplyPermissions,
    ValidationErrorToTooltip,
    ShowLoading,
    HideLoading,
    CloseAllMenus
} from "../Core/utils/document.utils";

// Import services from menu.service.ts
import { menuAdd, menuRemove, menuSave } from "../Core/services/menu.service";
// Import services from email.service.ts
import { emails, emailsRemove, emailsSave } from "../Core/services/email.service";

// Import models from menu.model.ts
import { MenuImpl, MenuWrapperImpl } from "../Core/models/menu.model";
// Import models from email.model.ts
import { EmailImpl, EmailWrapperImpl } from "../Core/models/email.model";

// Verify jQuery is working
console.log('jQuery is working!');
//console.log($); // Should log the jQuery function

// Expose utilities globally (grouped by file)
// From ajax.utils.ts
(window as any).InCoreReloadPartial = InCoreReloadPartial;
(window as any).InCoreReloadPartialAsync = InCoreReloadPartialAsync;
(window as any).InCoreReloadDivs = InCoreReloadDivs;
(window as any).InCoreAjaxRedirect = InCoreAjaxRedirect;

// From validation.utils.ts
(window as any).isNumber = isNumber;

// From toast.utils.ts
(window as any).InCoreToast = InCoreToast;
(window as any).InCoreToastX = InCoreToastX;
(window as any).InCoreToastCustom = InCoreToastCustom;
(window as any).InCoreToastType = InCoreToastType;
(window as any).InCoreToastPosition = InCoreToastPosition;

// From tabpanel.utils.ts
(window as any).initializeTabPanels = initializeTabPanels;
(window as any).activateTabPanel = activateTabPanel;

// From summernote.utils.ts
(window as any).initializeSummernote = initializeSummernote;
(window as any).activateSummernote = activateSummernote;

// From select2.utils.ts
(window as any).initializeSelect2 = initializeSelect2;
(window as any).InCoreSelect2 = InCoreSelect2;
(window as any).configureSelect2 = configureSelect2;
(window as any).InCoreSelect2Filter = InCoreSelect2Filter;

// From notification.utils.ts
(window as any).InCoreNotifier = InCoreNotifier;

// From permissions.utils.ts
(window as any).InCoreCheckPermission = InCoreCheckPermission;
(window as any).InCoreHasPermission = InCoreHasPermission;

// From modal.utils.ts
(window as any).InCoreModal = InCoreModal;
(window as any).CloseModal = CloseModal;
(window as any).CloseModalPromise = CloseModalPromise;
(window as any).ClearModal = ClearModal;
(window as any).InCoreModalAction = InCoreModalAction;
(window as any).InCoreModalLayout = InCoreModalLayout;

// From dropzone.utils.ts
(window as any).InitializeDropzones = initializeDropzones;
(window as any).InitDropzone = initDropzone;
(window as any).CreateDropzone = createDropzone;
(window as any).PreparaFormDropzone = preparaFormDropzone;

// From dom.utils.ts
(window as any).getBtn = getBtn;
(window as any).getParentBtn = getParentBtn;

// From datatable.utils.ts
(window as any).InCoreDT = InCoreDT;
(window as any).InCoreDTCustom = InCoreDTCustom;
(window as any).InCoreDTFromModel = InCoreDTFromModel;
(window as any).InCoreReadDTConfig = InCoreReadDTConfig;
(window as any).DTManageActions = DTManageActions;
(window as any).loadDataTablesFromJSON = loadDataTablesFromJSON;
(window as any).formatColumns = formatColumns;
(window as any).InCoreDTActions = InCoreDTActions;
//(window as any).PaginationConfiguration = PaginationConfiguration;

// From flatpickr.utils.ts
(window as any).initializeDateTimePickers = initializeDateTimePickers;
(window as any).InCoreDateTimePickerConfig = InCoreDateTimePickerConfig;
(window as any).InCoreDateTimePickers = InCoreDateTimePickers;
(window as any).createDateTimePicker = createDateTimePicker;
(window as any).InCoreDateTimePickerModes = InCoreDateTimePickerModes;

// From format.utils.ts
(window as any).InCoreFlashColor = InCoreFlashColor;
(window as any).InCoreFlashBorder = InCoreFlashBorder;

// From chart.utils.ts
(window as any).InCoreCalendarWindowType = InCoreCalendarWindowType;
(window as any).InCoreChartResizeOnWindow = InCoreChartResizeOnWindow;
(window as any).InCoreChartDestroy = InCoreChartDestroy;
(window as any).InCoreChartGetDataset = InCoreChartGetDataset;

// From calendar.utils.ts
(window as any).initializeCalendars = initializeCalendars;
(window as any).InCoreCalendar = inCoreCalendar;
(window as any).InCoreCalendarCustom = inCoreCalendarCustom;
(window as any).refreshCalendars = refreshCalendars;
(window as any).adjustCalendarHeight = adjustCalendarHeight;
(window as any).InCoreCalendarClosePopover = closeMoreLinkPopover;

// From swal.utils.ts
(window as any).InCoreSwal2 = InCoreSwal2;
(window as any).InCoreSwal2Icon = InCoreSwal2Icon;
(window as any).InCoreSwal2Type = InCoreSwal2Type;
(window as any).InCoreSwal2X = InCoreSwal2X;
(window as any).InCoreSwal2Custom = InCoreSwal2Custom;
(window as any).InCoreSwal2CustomPartial = InCoreSwal2Custom;

// From document.utils.ts
(window as any).BoldLastWordOfBreadcrumb = BoldLastWordOfBreadcrumb;
(window as any).InCoreApplyPermissionsDefault = InCoreApplyPermissionsDefault;
(window as any).InCoreApplyPermissions = InCoreApplyPermissions;
(window as any).ValidationErrorToTooltip = ValidationErrorToTooltip;
(window as any).ShowLoading = ShowLoading;
(window as any).HideLoading = HideLoading;
(window as any).CloseAllMenus = CloseAllMenus;

// Expose services globally (grouped by file)
// From menu.service.ts
(window as any).menuAdd = menuAdd;
(window as any).menuRemove = menuRemove;
(window as any).menuSave = menuSave;

// From email.service.ts
(window as any).emails = emails;
(window as any).emailsRemove = emailsRemove;
(window as any).emailsSave = emailsSave;

// Expose models globally (grouped by file)
// From menu.model.ts
(window as any).MenuImpl = MenuImpl;
(window as any).MenuWrapperImpl = MenuWrapperImpl;

// From email.model.ts
(window as any).EmailImpl = EmailImpl;
(window as any).EmailWrapperImpl = EmailWrapperImpl;

import Chart from 'chart.js/auto';
(window as any).Chart = Chart;

// Import Bootstrap (ESM) and expose it globally
import bootstrap from 'bootstrap';
(window as any).bootstrap = bootstrap;

// Optional: init tooltips/popovers
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
        .forEach(el => new bootstrap.Tooltip(el as HTMLElement));
    document.querySelectorAll('[data-bs-toggle="popover"]')
        .forEach(el => new bootstrap.Popover(el as HTMLElement));
});


// Example usage of imported modules
console.log("InCore Framework initialized!");

// Initialize core utilities
InCoreNotifier();
initializeTabPanels();
initializeSelect2();
initializeSummernote();
initializeCalendars();
initializeDropzones();
initializeDateTimePickers();